var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoSkill18(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5087_21665)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 4.2C2.30817 4.2 1.95 4.55817 1.95 5V13C1.95 13.4418 2.30817 13.8 2.75 13.8H16.75C17.1918 13.8 17.55 13.4418 17.55 13V5C17.55 4.55817 17.1918 4.2 16.75 4.2H2.75ZM0.75 5C0.75 3.89543 1.64543 3 2.75 3H16.75C17.8546 3 18.75 3.89543 18.75 5V13C18.75 14.1046 17.8546 15 16.75 15H2.75C1.64543 15 0.75 14.1046 0.75 13V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3763 6.3332C11.6497 6.05983 12.0929 6.05983 12.3663 6.3332C12.6397 6.60657 12.6397 7.04978 12.3663 7.32315L10.74 8.9495L12.3663 10.5758C12.6397 10.8492 12.6397 11.2924 12.3663 11.5658C12.0929 11.8391 11.6497 11.8391 11.3763 11.5658L9.75003 9.93945L8.12368 11.5658C7.85032 11.8391 7.4071 11.8391 7.13374 11.5658C6.86037 11.2924 6.86037 10.8492 7.13374 10.5758L8.76008 8.9495L7.13374 7.32315C6.86037 7.04978 6.86037 6.60657 7.13373 6.3332C7.4071 6.05983 7.85032 6.05983 8.12368 6.3332L9.75003 7.95955L11.3763 6.3332Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5087_21665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSkill18);
export default __webpack_public_path__ + "11f803a6d314576f0d352bcb8b176058.svg";
export { ForwardRef as ReactComponent };